import axios from "axios";

export default defineNuxtPlugin((NuxtApp) => {
  const $axios = axios;
  const $env = NuxtApp.$env;

  // Create a custom axios instance
  const axiosInstance = $axios.create({
    baseURL: `${$env.jobs.apiUrl}`
  });
  const jobs = {};

  jobs.Exclusivity = {
    match: (params) => {
      return axiosInstance.post(`/exclusivities/match`, params)      
    },
    track: (params) => {
      return axiosInstance.post(`/analytics/exclusivity`, params)      
    }
  }

  NuxtApp.$store.$jobs = jobs;

  // Inject to context as $jobs
  return {
    provide: {
      jobs
    }
  }
})

